import * as z from 'zod'
import { dateSchema } from '~/shared/lib/schemas'

import { ApiModel } from './core'

const attributeSchema = z.object({
  name: z.string(),
  isEditForDriver: z.boolean(),
})

const schema = z
  .object({
    createdAt: dateSchema.optional(),
    updatedAt: dateSchema.optional(),
  })
  .merge(attributeSchema)

export type RentalServiceAttributes = z.infer<typeof schema>

export class RentalService extends ApiModel<typeof schema> {
  static jsonApiType = 'rental-services'

  static schema = schema

  getName(): string {
    return this.getAttribute('name')
  }
  getIsEditForDriver(): boolean {
    return this.getAttribute('isEditForDriver')
  }
}
